import { IFormData, IFormModal } from '~/types/form'
import { IStrapiDataComponent } from '~/types/strapi'
import cmsApi from '~/utils/cms-api'

export interface IValidationError {
  target: string
  message: string
}

const getHubspotContext = () => {
  const hutk = window.storageCookie?.getValue('hubspotutk')
  return {
    hutk,
    pageName: document.title,
    pageUri: window.location.href,
  }
}

export async function sendForm(formId: number, data: unknown) {
  const context = getHubspotContext()
  await cmsApi.post(`/uk-forms/register/${formId}`, {
    data,
    context,
  })
}

export const getFormById = async (
  id: number
): Promise<IStrapiDataComponent<IFormData> | false> => {
  try {
    const response = await cmsApi.get(`/uk-form/${id}`, {
      populate: 'deep,3',
    })

    if (!response.data?.attributes) {
      throw new Error('Form data not found')
    }

    return response
  } catch (error) {
    console.error(error)
    return false
  }
}

export const sanitizeFormModalData = async (
  modal: IFormModal
): Promise<IFormModal | false> => {
  const formId = modal.ukForm?.data?.id

  if (!formId) {
    return false
  }

  const ukForm = await getFormById(formId)

  if (!ukForm) {
    return false
  }

  return {
    ...modal,
    ukForm,
  }
}
